module.exports = __webpack_public_path__ + "static/media/Single Matting Verticial.5fa2f10b.png";